import { RegexValue } from "clarity-pattern-parser";

const divider = new RegexValue("divider", "\\s*[,]\\s*");

export default divider;
